module.exports = __webpack_public_path__ + "img/lottery-bg.f28900a2.png";